import {call, put, delay} from 'redux-saga/effects';
import {last} from 'helpers';

export function* sessionCheckUpdate() {
  while (true) {
    try {
      yield delay(5*60*1000);
      const loadedScript = document.getElementById('main-script').getAttribute('src');
      const result = yield call(window.fetch, '/?' + Math.random());
      const text = yield call(result.text.bind(result));
      const currentScript = last(/main-script.*src="([^"]+)/.exec(text));
      if (currentScript != loadedScript) {
        yield put({
          type: 'SESSION_NEW_VERSION_AVAILABLE',
        });
      }
    } catch (error) {
      yield put({
        type: 'CHECK_UPDATE_ERROR',
        error,
      });
    }
  }
}
